<template>
<div>
  <section class="firstSection">
    <b-container fluid class="bestPos">
      <b-row align-v="center" class="marginLeft">
        <b-col sm class="mt-3">
          <!-- <h1 class="display-4" style="color:purple">ezFix'd</h1>
          <p class="lead" style="color:grey">Car repairs made simple.</p> -->
          <h1 class="h4">Unexpected car repair?</h1><br />
          <h2 class="title">Fix your car and pay later <br />with rates starting at 0%!</h2>
          <p class="mt-4">ezFix'd was founded to be there for people when they need excellent car repair services with an efficient, speedy trustworthy solution for financing.

          </p>
        </b-col>
        <b-col sm>
          <img src="../assets/images/color/color-3/fam.png" class="img-fluid">
        </b-col>
      </b-row>
    </b-container>
  </section>
  <div class="container">
      <!-- Three columns of text below the carousel -->
      <div class="row">
        <div class="col-lg-4">
          <img class="center img-fluid" src="../assets/images/color/color-3/customer-care.svg" v-bind="mainPropsTransparency" rounded="circle" alt="Circle image">
          <h2 class="mt-3 text-center">Support</h2>
          <p>Customer satisfaction is our team's highest priority</p>
        </div><!-- /.col-lg-4 -->
        <div class="col-lg-4">
          <img class="center img-fluid" src="../assets/images/color/color-3/reliability.svg" v-bind="mainPropsTransparency" rounded="circle" alt="Circle image">
          <h2 class="mt-3 text-center">Transparency</h2>
          <p>With our technology we make sure everything is transparent and complete for you to access anytime.</p>
        </div><!-- /.col-lg-4 -->
        <div class="col-lg-4">
          <img class="center text-center img-fluid" src="../assets/images/color/color-3/time-management.svg" v-bind="mainPropsEfficiency" rounded="circle" alt="Circle image">
          <h2 class="mt-3 text-center">efficieny</h2>
          <p>We built a platform to eliminate uncessary wait times and maximize efficiency</p>
        </div><!-- /.col-lg-4 -->
      </div><!-- /.row -->


      <!-- START THE FEATURETTES -->

      <hr class="featurette-divider">

      <div class="row featurette mt-5">
        <div class="col-md-7 mt-5">
          <h2 class="featurette-heading">Our car repair services <span class="text-muted"> are closely Monitored and reviewed</span></h2>
          <p class="lead">We developed processes to track and monitor your car repair leading to a better customer experience and better results</p>
        </div>
        <div class="col-md-5">
          <img src="../assets/images/color/color-3/monitormc.png" class="img-fluid lgimages">

  <!-- <b-img src="../assets/images/color/color-3/monitor.jpg" fluid-grow alt="Fluid-grow image"></b-img>
          <svg class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" width="500" height="500" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><title>Car repair</title><rect width="100%" height="100%" fill="#eee"></rect><text x="50%" y="50%" fill="#aaa" dy=".3em">500x500</text></svg> -->
        </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette mt-5">
        <div class="col-md-7 order-md-2 mt-5">
          <h2 class="featurette-heading">Car repair financing? No credit checks <span class="text-muted">or income verfication</span></h2>
          <p class="lead">You can get preapproved within minutes, just enter your VIN number and odometer. Our system will review the vehicle's details and assess your application instantly.</p>
        </div>
        <div class="col-md-5 order-md-1">
          <img src="../assets/images/color/color-3/paymentplan.png" class="img-fluid lgimages">

        </div>
      </div>

      <hr class="featurette-divider">

      <div class="row featurette mt-5">
        <div class="col-md-7 mt-5">
          <h2 class="featurette-heading">Speedy<span class="text-muted"> Service</span></h2>
          <p class="lead">We know you need your vehicle repaired as fast as possible, you can get approved for a payment plan between 500$-10,000$ in less than 10 minutes!</p>
        </div>
        <div class="col-md-5">
          <img src="../assets/images/color/color-3/speedfly.png" class="img-fluid lgimages">

        </div>
      </div>

      <hr class="featurette-divider">

      <!-- /END THE FEATURETTES -->

    </div>

</div>
</template>

<script>
export default {
  name: 'AboutUs',
  data(){
    return {
            mainPropsSupport: { blank: false, blankColor: '#777', width: 150, height: 150, class: 'm1' },
            mainPropsTransparency: { blank: true, blankColor: '#777', width: 150, height: 150, class: 'm1' },
            mainPropsEfficiency: { blank: true, blankColor: '#777', width: 150, height: 150, class: 'm1' }
          }
  },

  mounted() {
    document.querySelector('.navbar').classList.add('darkHeader')
  },
  methods: {},
}

</script>

<style scoped>


@media (max-width: 576px) {
  img.lgimages {
        width: 400px;
    }
    .bestPos{
      padding-top: 3rem;
    }
    .marginLeft{
      margin-left: 10px;
    }
  }


// Medium devices (tablets, 768px and up)
@media (max-width: 768px) {
  img.lgimages {
        width: 250px;
    }
    .marginLeft{
      margin-left: 90px;
    }

  }

// Large devices (desktops, 992px and up)
@media (max-width: 992px) {   img.lgimages {
        width: 700px;
    }
    .marginLeft{
      margin-left: 90px;
    }
  }


// Extra large devices (large desktops, 1200px and up)
@media (max-width: 1200px) {   img.lgimages {
        width: 700px;
    }
    .marginLeft{
      margin-left: 90px;
    }
  }

.firstSection{
  padding-bottom: 10px;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.container {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.box {
  padding: 2rem;
  border-top: 3px solid #40c991;
}

select,
input {
  border-radius: 1rem;
  max-width: 350px;
  margin: 1.5rem auto 0 auto;
}

select:focus,
input:focus {
  box-shadow: none;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}
h1{
  font-size: 3rem;
  font-weight: bolder;
  color: #F15B22 ;
}

h2.title{
  font-size: 2rem;
  font-weight: bold;
  color: #009579 ;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #7b7e7d;
}

.awesome {
  color: #40c991;
}
/* Resets */
hr {
  margin-left: 0;
  max-width: 40px;
}

/* Jumbotron (hero) */
.jumbotron {
  position: relative;
  background: url(../assets/images/color/color-3/team-bg.png) no-repeat bottom center / cover;
  padding-top: 10%;

  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }

  .container {
    padding: 0px 0;
  }

  h1,
  .lead {
    color: #fff;
  }
}

/* Bustom button */
.btn-primary {
  background: #1096fc;
  border: 0;

  &:hover {
    background: darken(#1096fc, 7%);
  }
}

/* Features */
.sec-features {
  .row {
    &:nth-of-type(n+2) {
      margin-top: 160px;
    }

    &:last-of-type {
      margin-bottom: 160px;
    }
  }

  .feature-icon {
    max-width: 150px;
  }
}

/* Testimonials */
.sec-testimonials {
  padding-top: 128px;
  padding-bottom: 128px;
}

/* Carousel */
.carousel-indicators {
  bottom: -30px;

  li {
    background: rgba(33, 33, 33, .1);

    &:focus,
    &:hover {
      background: rgba(33, 33, 33, .5);
    }
  }

  .active {
    background: rgba(33, 33, 33, .75);
  }
}

.carousel-control-next,
.carousel-control-prev {
  & {
    color: #212121;
  }

  &:focus,
  &:hover {
    color: #111;
  }
}

/* Footer */
.footer {
  padding-top: 24px;
  padding-bottom: 24px;
  background: #212121;

  li {
    &:nth-of-type(n+2) {
      margin-left: 8px;
    }
  }

  a {
    font-size: 18px;
    color: rgba(255, 255, 255, .5);
    transition: color .235s ease-in-out;

    &:focus,
    &:hover {
      color: rgba(255, 255, 255, .25);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutus.vue